interface MapLoadingOverlayProps {
  isLoading: boolean;
}

/** 지도 영역 중앙 스피너만 표시 (전체 화면 딤 없음) */
const MapLoadingOverlay = ({ isLoading }: MapLoadingOverlayProps) => {
  if (!isLoading) return null;

  return (
    <div
      className="pointer-events-none absolute inset-0 z-[62] flex items-center justify-center"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="flex h-[52px] w-[52px] items-center justify-center rounded-full bg-white shadow-md ring-1 ring-black/[0.08]">
        <div
          className="h-7 w-7 animate-spin rounded-full border-[3px] border-[#1562fc] border-t-transparent"
          aria-hidden
        />
      </div>
      <span className="sr-only">매장 정보를 불러오는 중</span>
    </div>
  );
};

export default MapLoadingOverlay;
